/** Combined lab-create credentials file (one row per user in the batch). */

export const PMA_PROVISION_REPORT_FILENAME = 'lab_linux_vnc_credentials.csv';

export const PMA_PROVISION_REPORT_COLUMNS = Object.freeze([
  'userId',
  'userName',
  'email',
  'status',
  'host',
  'systemType',
  'linuxPassword',
  'vncPassword',
  'vncPort',
  'vncFqdn',
  'puttyFqdn',
  'linuxGroup',
  'dryRun',
  'message',
]);

function csvCell(value) {
  const text = value == null ? '' : String(value);
  if (/[",\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
}

export function mapLabUserToReportRow(user = {}) {
  const hosts = user.hosts || user.linuxHosts || [];
  const host = hosts[0] || user.host || user.vncFqdn || user.puttyFqdn || '';
  return {
    userId: user.userId || '',
    userName: user.userName || '',
    email: user.emailId || user.email || '',
    status: user.status || '',
    host: typeof host === 'string' ? host : '',
    systemType: user.systemType || '',
    linuxPassword: user.linuxPassword || '',
    vncPassword: user.vncPassword || '',
    vncPort: user.vncPort != null && user.vncPort !== '' ? String(user.vncPort) : '',
    vncFqdn: user.vncFqdn || '',
    puttyFqdn: user.puttyFqdn || '',
    linuxGroup: user.linuxGroup || '',
    dryRun: user.dryRun ? 'true' : 'false',
    message: user.error || user.errorMessage || user.message || (user.status === 'created' ? 'ok' : ''),
  };
}

export function buildProvisionReportRows(users = []) {
  return (users || []).map(mapLabUserToReportRow);
}

export function buildProvisionReportCsv(users = []) {
  const rows = buildProvisionReportRows(users);
  const lines = [PMA_PROVISION_REPORT_COLUMNS.join(',')];
  for (const row of rows) {
    lines.push(PMA_PROVISION_REPORT_COLUMNS.map((key) => csvCell(row[key])).join(','));
  }
  return `${lines.join('\n')}\n`;
}
